export default {
  competitor: (purchaseProfile) => {
    const showdownPacks = purchaseProfile.showdownPacks || {}
    return showdownPacks['eliteGamerShowdownDecember2018']
  },
  prizePool: (count) => {
    return Math.floor(Math.min(25 + count / 2, 100))
  },
}



// WEBPACK FOOTER //
// ./src/app/filters/competitions.js